export enum InfoStocksTabEnum {
	DESCRIPTION = 'description',
	STATISTICS = 'statistics',
	ANALYTICS = 'analytics',
}
